<template>
  <div>

    <div class="colspan"
         :style="$route.query.id?'':{marginTop:'84px'}">
      <h2>{{detailData.title}}</h2>
      <div>
        <span>{{$dateToConver(detailData.publish_at)}}</span>
        <i class="el-icon-view"></i>
        <span>{{detailData.page_view}}</span>
      </div>
      <el-carousel v-if="detailData.type==2"
                   :interval="5000"
                   arrow="always"
                   height="350px"
                   class="lbFather"
                   style="width:580px;margin-top:30px">
        <el-carousel-item :key="index"
                          v-for="(item,index) in detailData.subsidiary_files">
          <img v-lazy="item.pub_file_text.url"
               class="lubotu" />
        </el-carousel-item>
      </el-carousel>

      <div v-if="detailData.type==3 "
           :key="index"
           v-for="(item,index) in detailData.subsidiary_files"
           style="margin-top:30px">
        <!-- {{item.code}} -->
        <iframe height="420"
                width="850"
                :src="item.code_url"
                frameborder="0"></iframe>
      </div>
      <p v-html="detailData.content"
         style="min-height:500px"></p>
      <div class="share">
        分享到：
        <share :config="vshareConfig"></share>
        <div class="social-share">
          <a class="social-share-icon icon-wechat"
             href="javascript:">
            <div class="wechat-qrcode">
              <h4>微信扫一扫：分享</h4>
              <div class="qrcode"
                   :title="vshareConfig.url">
                <canvas width="100"
                        height="100"
                        style="display: none;"></canvas>
                <div ref='qrcode'
                     id="qrcode"></div>
              </div>
              <div class="help">
                <p>微信里点“发现”，扫一下。 二维码便可将本文分享至朋友圈。</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  props: {
    detailData: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      isPic: false,
      vshareConfig: {
        url: this.$moblieUrl + "newsDetails?id=" + this.$route.query.newsId, // 网址，默认使用 window.location.href
        title: "",
        description: "",
        // source : '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        // title : '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        // description : '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: ["weibo", "qq", "qzone"], // 启用的站点
        // disabled : ['google', 'facebook', 'twitter'], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>"
      },
      // vshareConfig: {
      //   shareList: [
      //     // 此处放分享列表（ID）
      //     "qzone",
      //     "tsina",
      //     "sqq",
      //     "weixin"
      //   ],
      //   common: {
      //     //此处放置通用设置
      //     bdUrl: window.location.href,
      //     bdText: "",
      //     bdDesc: "",
      //     bdPic: ""
      //   }
      // },
      detail_id: this.$route.query.newsId //新闻id
    };
  },
  methods: {
    //分享信息
    getNewData () {
      this.$db
        .get(this.$url.document.url + "/" + this.detail_id)
        .then(resp => {
          let data = resp.data;
          this.vshareConfig.title = data.title;
          this.vshareConfig.description = data.description;
          this.vshareConfig.image = data.cover_photo_text.url;
        })
        .catch(err => {
          console.log(err);
        });
    },
    qrcode () {
      let qrcode = new QRCode(this.$refs.qrcode, {
        width: 100,
        height: 100,
        text: this.vshareConfig.url, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff"
      });
    }
  },
  created () {
    this.getNewData();
  },
  mounted () {
    this.qrcode();
  },
  beforeCreate () {
    window._bd_share_main = "";
  },
  watch: {
    detailData: function (value) {
      if (value) {
        if (value.type == 4) {
          if (value.content) {
            window.open(value.content, "_blank");
            if (this.$route.query.preview == 1) {
              this.$router.push({ path: "/" });
            } else {
              this.$router.go(-1);
            }
          }
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.head-box {
  color: #888888;
  text-align: center;
  padding-bottom: r(40);
  > h2 {
    color: #404040;
    font-weight: normal;
  }
  > span {
    font-size: r(32);
  }
}
.colspan {
  margin: 0 auto;
  width: 1200px;
  min-height: 800px;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: border-box;
  padding: 0 30px;
  padding-bottom: 50px;
  position: relative;
  > h2 {
    text-align: center;
    font-size: 36px;
  }
  > div {
    text-align: center;
    font-size: 16px;
    color: #888;
    > span:nth-of-type(1) {
      margin-right: 30px;
    }
  }
  .lbFather {
    position: relative;
    text-align: center;
    margin: 0 auto;
  }
  .lubotu {
    color: #333;
    width: 100%;
    height: 100%;
  }
  /deep/ p {
    > img {
      max-width: 100%;
    }
  }
  .share {
    height: 50px;
    line-height: 50px;
    font-size: 12px;
    color: #666;
    // display: flex;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 30px;
    .social-share {
      float: right;
    }
  }
}
</style>
<style scoped>
.social-share .icon-wechat .wechat-qrcode .help {
  padding: 0, 40px;
}
.social-share .icon-wechat .wechat-qrcode .help p {
  font-weight: normal;
  line-height: 16px;
  margin: 0;
}
.social-share .social-share-icon {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  font-size: 20px;
  border-radius: 50%;
  line-height: 32px;
  border: 1px solid #666;
  color: #666;
  text-align: center;
  vertical-align: middle;
  transition: background 0.6s ease-out 0s;
}
.social-share .social-share-icon:hover {
  background: #666;
  color: #fff;
}
.social-share .icon-wechat {
  position: relative;
  color: #7bc549;
  border-color: #7bc549;
}
.social-share .icon-wechat:hover {
  background: #7bc549;
}
.social-share .icon-wechat .wechat-qrcode {
  display: none;
  border: 1px solid #eee;
  position: absolute;
  z-index: 9;
  top: -205px;
  left: -84px;
  width: 200px;
  height: 192px;
  color: #666;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 2px 10px #aaa;
  transition: all 200ms;
  -webkit-tansition: all 350ms;
  -moz-transition: all 350ms;
}
.social-share .icon-wechat .wechat-qrcode.bottom {
  top: 40px;
  left: -84px;
}
.social-share .icon-wechat .wechat-qrcode.bottom:after {
  display: none;
}
.social-share .icon-wechat .wechat-qrcode h4 {
  font-weight: normal;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  background-color: #f3f3f3;
  margin: 0;
  padding: 0;
  color: #777;
}
.social-share .icon-wechat .wechat-qrcode .qrcode {
  width: 105px;
  margin: 10px auto;
}
.social-share .icon-wechat .wechat-qrcode .qrcode table {
  margin: 0 !important;
}
.social-share .icon-wechat .wechat-qrcode:after {
  content: "";
  position: absolute;
  left: 50%;
  margin-left: -6px;
  bottom: -13px;
  width: 0;
  height: 0;
  border-width: 8px 6px 6px 6px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
}
.social-share .icon-wechat:hover .wechat-qrcode {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamics/detailsInfo.vue